import styled from 'styled-components';

import Picture from 'components/picture';

interface IPictureProps {
  clipPathId: string;
}

export const Wrapper = styled.button`
  display: block;
  appearance: none;
  border: none;
  margin: 0;
  padding: 0;
  font-size: inherit;
  font-family: ${Styles.fontFamily.base};
  position: relative;
  text-align: left;
  background: transparent;
  z-index: 0;
  user-select: none;
  cursor: pointer;
`;

export const Content = styled.div`
  position: relative;
  color: ${Styles.color.white};
  display: flex;
  flex-direction: column;
  // min-height: 10.625rem;
  text-shadow: rgba(0, 0, 0, 0.5) 1px 0 10px;
  padding: 1rem 1.5rem;
  z-index: ${Styles.zIndex.below};
  min-height: 150.391px;
`;

export const HeaderContent = styled.div`
  display: flex;
`;

export const StyledPicture = styled(Picture)<IPictureProps>`
  clip-path: url(#${p => p.clipPathId});
  border-radius: ${Styles.borderRadius};
  position: relative;
  width: calc(100vw - 1rem);
  min-height: 150.391px;

  @media (min-width: 366px) {
    width: 350px;
  }

  &::after {
    content: '';
    position: absolute;
    background-image: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.75) 0%,
      rgba(0, 0, 0, 0.25) 35%,
      rgba(0, 0, 0, 0.25) 65%,
      rgba(0, 0, 0, 0.75) 100%
    );
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
`;

export const Heading = styled.h3`
  text-transform: uppercase;
  font-family: ${Styles.fontFamily.base};
  margin: 0 0 0.15rem;
  font-size: 1.5rem;
  line-height: 1;
  flex-grow: 1;

  & small {
    font-size: 0.55em;
  }
`;

export const Body = styled.div`
  font-family: ${Styles.fontFamily.body};
  line-height: 1.25;
  font-size: 0.8125rem;
  padding: 0.1rem 0;
`;

export const Footer = styled.div`
  font-family: ${Styles.fontFamily.body};
  font-weight: ${Styles.fontWeight.heavy};
  font-size: 0.75rem;
  height: 0.75rem;

  ${Styles.desktop`
    font-size: 0.625rem;
  `}
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-height: calc(150.391px - 2rem);
`;

export const UpperTextOffer = styled.div`
  min-height: calc(150.391px - 2rem - 0.75rem);
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const FlagsWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: ${Styles.zIndex.below};
  display: flex;
`;
